import React from 'react';
import { Select } from '../../components/ui/select';
import { metricMeta } from './metricTone';

/**
 * Compact metric picker for a block header, built on the shadcn Select.
 * Renders null for fewer than two options, so a caller with a single-metric
 * run needs no guard of its own.
 *
 * options: array of metric names; value/onChange are the selected name.
 */
const MetricSelect = ({ options = [], value, onChange }) => {
  if (options.length < 2) return null;
  return (
    <Select
      size="sm"
      align="end"
      label="Metric"
      ariaLabel={`Metric: ${metricMeta(value).label}`}
      value={value}
      onValueChange={onChange}
      options={options.map((name) => ({ value: name, label: metricMeta(name).label }))}
    />
  );
};

export default MetricSelect;
